import React from 'react';

import { Box, Card, CardContent, Grid, Typography } from '@mui/material';

import { formatMoney } from 'utils';

import { User } from '../../../types/user';

type Props = {
  strategiesCount: number;
  totalClients: number;
  totalAssets: number;
  user: User | null;
};

export const SummaryCards: React.FC<Props> = ({ strategiesCount, totalClients, totalAssets, user }) => {
  const cardStyle = {
    transition: 'all 0.2s',
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: 6,
    },
  };

  const hasRating =
    user?.rating !== null &&
    user?.rating !== undefined &&
    user?.placeInRating !== null &&
    user?.placeInRating !== undefined;

  return (
    <Grid container spacing={3} sx={{ mb: 4 }}>
      <Grid item xs={12} sm={6} md={3}>
        <Card sx={cardStyle}>
          <CardContent>
            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
              <Box sx={{ flex: 1 }}>
                <Typography color="text.secondary" variant="overline" display="block" gutterBottom>
                  Рейтинг
                </Typography>
                <Typography variant="h5" component="div" sx={{ fontWeight: 700, color: 'primary.main' }}>
                  {hasRating ? user!.rating!.toFixed(1) : 'отсутствует'}
                </Typography>
              </Box>
              {hasRating && (
                <Box sx={{ flex: 1 }}>
                  <Typography color="text.secondary" variant="overline" display="block" gutterBottom>
                    Место
                  </Typography>
                  <Typography variant="h5" component="div" sx={{ fontWeight: 700, color: 'primary.main' }}>
                    {user!.placeInRating} из {user!.totalAuthors || 0}
                  </Typography>
                </Box>
              )}
            </Box>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <Card sx={cardStyle}>
          <CardContent>
            <Typography color="text.secondary" variant="overline" display="block" gutterBottom>
              Всего стратегий
            </Typography>
            <Typography variant="h5" component="div" sx={{ fontWeight: 700, color: 'primary.main' }}>
              {strategiesCount}
            </Typography>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <Card sx={cardStyle}>
          <CardContent>
            <Typography color="text.secondary" variant="overline" display="block" gutterBottom>
              Всего клиентов
            </Typography>
            <Typography variant="h5" component="div" sx={{ fontWeight: 700, color: 'primary.main' }}>
              {totalClients}
            </Typography>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <Card sx={cardStyle}>
          <CardContent>
            <Typography color="text.secondary" variant="overline" display="block" gutterBottom>
              Общая сумма активов
            </Typography>
            <Typography variant="h5" component="div" sx={{ fontWeight: 700, color: 'primary.main' }}>
              {formatMoney(totalAssets, 'RUB')}
            </Typography>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};
